module.exports = __webpack_public_path__ + "static/media/27-min.jpg.226d4623.webp";